/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddDetailPage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 13a4 4 0 0 1 3.447 6.031l2.26 2.262-1.414 1.414-2.262-2.26A4 4 0 1 1 16 13zM14.414 2 21 8.586V12h-2v-2h-6l-.001-6H5v16h6v2H3V2zM16 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-1-9.585V8h2.585z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAddDetailPage as AddDetailPage };
